/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Immutable from 'immutable';

import SpaceshipState from 'astro/fake/state/spaceship';


export default (spaceships) =>
{
  let state = new Immutable.Map();

  for (const spaceship of spaceships)
  {
    state = state.set(spaceship.getID(), SpaceshipState(spaceship));
  }

  return state;
}
